export default {
  projectTypeList: []
};
